export default {
      id: "menu__car-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.svg#menu__car",
      toString: function () {
        return this.url;
      }
    }